// Handles native Web Share API and minor UX for the share toolbar
document.addEventListener('DOMContentLoaded', function () {
    if (typeof window === 'undefined') return;

    function handleNativeShare(btn) {
        const title = btn.dataset.title || document.title;
        const url = btn.dataset.url || window.location.href;

        if (navigator.share) {
            navigator.share({ title: title, url: url }).catch(function (err) {
                // user cancelled or failed — no-op
                // console.debug('share error', err);
            });
            return true;
        }
        return false;
    }

    document.body.addEventListener('click', function (ev) {
        const btn = ev.target.closest && ev.target.closest('.share-toolbar .share-btn.native');
        if (!btn) return;
        ev.preventDefault();
        const used = handleNativeShare(btn);
        if (!used) {
            // Fallback: open a small window to let user pick via Twitter by default
            const url = btn.dataset.url || window.location.href;
            const title = btn.dataset.title || document.title;
            const shareUrl = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(title) + '&url=' + encodeURIComponent(url);
            window.open(shareUrl, '_blank', 'noopener,width=600,height=420');
        }
    });

});
